// Option lists for Workshops — must match backend/workshops.js (the backend
// validates every value against its own copy of these).

// In order. Info Complete is set automatically (a confirmed leader whose
// info is all in) — the backend reads older 'Info Submitted' rows as Invited.
export const LEADER_STATUSES = ['Planned', 'Invited', 'Confirmed', 'Info Complete', 'Declined'];
// Both mean the leader has said yes.
export const isConfirmedStatus = (status) => status === 'Confirmed' || status === 'Info Complete';
// Which sessions a leader teaches. 'Either' = one session, whichever the
// schedule picks; 'Both Sessions' = Session 1 AND Session 2. (Older rows
// saved 'Both', meaning "either or both" — the backend reads it as 'Either'.)
export const ALLOWED_SESSIONS = ['Either', 'Both Sessions', 'Session 1', 'Session 2'];
export const CONTRACT_STATUSES = ['Not started', 'Draft', 'Sent', 'Signed'];

export const ALLOWED_SESSIONS_LABELS = {
  Either: 'One session — either one',
  'Both Sessions': 'Both sessions',
  'Session 1': 'Session 1 only',
  'Session 2': 'Session 2 only',
};

// How a workshop can play music — the leader ticks every way that works for
// them. Stored as a comma list: 'Bluetooth' and/or 'Aux' / 'Aux + USB-C
// adapter' / 'Aux + Lightning adapter'; blank = no music.
// The space then needs a speaker plus any ONE of the ticked ways (the
// backend sends these as setupNeeds + musicOptions). Must match parseMusic
// in backend/workshops.js.
export const AUX_ADAPTERS = [
  { value: '', label: 'None (headphone jack)' },
  { value: 'USB-C', label: 'USB-C' },
  { value: 'Lightning', label: 'Lightning (older iPhones)' },
];
// Covered by the music question, so not repeated in the equipment checklist.
export const MUSIC_ITEMS = ['Bluetooth', 'Aux cable', 'USB-C adapter', 'Lightning adapter'];

// '…' -> { bluetooth, aux, adapter }
export function parseMusic(setup) {
  const parts = String(setup || '').split(',').map(s => s.trim());
  const aux = parts.find(p => p.startsWith('Aux'));
  return {
    bluetooth: parts.includes('Bluetooth'),
    aux: !!aux,
    adapter: aux?.match(/\+ (\S+) adapter/)?.[1] || '',
  };
}
export function buildMusic({ bluetooth, aux, adapter }) {
  return [bluetooth && 'Bluetooth', aux && (adapter ? `Aux + ${adapter} adapter` : 'Aux')].filter(Boolean).join(', ');
}
export const musicLabel = (setup) => (setup ? `Music: ${setup.replace(', ', ' or ')}` : '');

export const PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp';
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;

// Shared blank workshop for "Add workshop" forms.
export const emptyWorkshop = () => ({
  workshopId: '', title: '', style: '', description: '', equipmentNeeded: [], musicSetup: '', maxDancers: '', requiredSpace: '',
});

export function leaderLinkUrl(token) {
  return `${window.location.origin}${process.env.PUBLIC_URL}/registration/workshop-leader?token=${encodeURIComponent(token)}`;
}
